// @ts-nocheck
import AssignmentForm from "./assignmentForm";
//--------------------------------------------------------------------------------------------
export default function LocatingPostChecklist({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Were the project boundaries and corners properly delineated?",  type: "radio", required: true},
        {title: "Were all utilities clearly marked using the standard marking procedures?",  type: "radio", required: true},
        {title: "Did you take pictures of all located utilities?",  type: "radio", required: true},
        {title: "Did you do a walk-through with the customer at the end of the GPR survey?", type: "radio", required: true},
        {title: "Were any utilities not located? If no, explain why.",  type: "radio", onNo: "textarea", required: true},
        {title: "Were any addresses missed? If yes, which ones? Why? Was PM notified?",  type: "radio", onYes: "textarea", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <AssignmentForm
            noPDF
            items = {items}
            {...rest}
        />
    )    
}
